// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".s-input{border:0;width:250px;padding:8px 14px;margin-bottom:20px}.input-title{margin-right:20px;width:70px;display:inline-block}.speed-input{border:1px solid #46aeff;padding:6px 9px;margin-bottom:11px;width:230px;color:#46aeff}.speed-input::placeholder{color:#46aeff;opacity:1}.speed-input:-ms-input-placeholder{color:#46aeff}.speed-input::-ms-input-placeholder{color:#46aeff}.speed-input:disabled{background-color:#dedede;cursor:not-allowed}", ""]);
// Exports
module.exports = exports;
